<template>
    <div class="ComparisonOfschHistory">
        <div class="filtrate Compare">
            <el-select v-model="Termid" placeholder="请选择" @change="gradeChange">
                <el-option v-for="item in gradeList" :key="item.term_id" :label="item.gradeText" :value="item.term_id">
                </el-option>
            </el-select>
            <el-select class="filter_select" v-model="Filtervalue" multiple collapse-tags style="margin-left: 20px;"
                placeholder="请选择" @change="changeFiltervalue">
                <el-option v-for="item in Filterdata" :key="item.keyvalue" :label="item.examName" :value="item.keyvalue">
                </el-option>
            </el-select>
            <div class="export flex-align"></div>
        </div>
        <div class="type_title flex-column-center">
            <h1>{{ $route.query.schoolName }}历次测评对比分析</h1>
        </div>
        <div class="overall_situation">
            <template v-if="!isEmpty">
                <div class="empty">
                    <el-empty description="暂无报告"></el-empty>
                </div>
            </template>
            <template v-else>
                <div class="BasicTemplate">
                    <div class="Secondary_heading">
                        <div class="vertical_grain_icon"></div> <span class="title">参与情况</span>
                    </div>
                    <div class="content">
                        <Short_form_SchoolComparison :construction="Participation_TableStructure"
                            :tabledata="Participation_Data" :row_high="Participation_high" slashType="close"
                            TableType="SchoolComparison">
                        </Short_form_SchoolComparison>
                        <div class="Participation_Chart">
                            <BarChart :InjectData="Participation_GraphicalData" Id="Participation" Title="参与率（%）"
                                XAxis="examName" SeriesDataName="totalSignInPercent" ChartType="百分比"></BarChart>
                        </div>
                    </div>
                    <div class="Secondary_heading">
                        <div class="vertical_grain_icon"></div> <span class="title">书写习惯统计情况</span>
                    </div>
                    <div class="content">
                        <Short_form_SchoolComparison :construction="GrippingPosture_TableStructure"
                            :tabledata="GrippingPosture_Data" :row_high="GrippingPosture_high" slashType="close">
                        </Short_form_SchoolComparison>
                        <div class="Participation_Chart">
                            <BarChart :InjectData="GrippingPosture_GraphicalData" Id="GrippingPosture" Title="握笔姿势错误人数"
                                XAxis="examName" SeriesDataName="errHoldPercent" ChartType="百分比">
                            </BarChart>
                        </div>
                    </div>
                    <div class="content">
                        <Short_form_SchoolComparison :construction="SittingPosture_TableStructure"
                            :tabledata="SittingPosture_Data" :row_high="SittingPosture_high" slashType="close">
                        </Short_form_SchoolComparison>
                        <div class="Participation_Chart">
                            <BarChart :InjectData="SittingPosture_GraphicalData" Id="SittingPosture" Title="坐姿错误人数"
                                XAxis="examName" SeriesDataName="errSitPercent" ChartType="百分比">
                            </BarChart>
                        </div>
                    </div>
                    <div class="Secondary_heading">
                        <div class="vertical_grain_icon"></div> <span class="title">等级分布情况</span>
                    </div>
                    <div class="content">
                        <Short_form_SchoolComparison :construction="Distribution_TableStructure"
                            :tabledata="Distribution_Data" :row_high="Distribution_high" slashType="close">
                        </Short_form_SchoolComparison>
                        <div class="Participation_Chart">
                            <ComparativeColumnChart :InjectData="Distribution_GraphicalData" Id="Distribution">
                            </ComparativeColumnChart>
                        </div>
                    </div>
                    <div class="Secondary_heading">
                        <div class="vertical_grain_icon"></div> <span class="title">学生分级人数统计</span>
                    </div>
                    <div class="content Classification">
                        <div class="ClassifiedStatistics">
                            <Short_form_SchoolComparison :construction="Classification_TableStructure"
                                :tabledata="Classification_Data" :row_high="Classification_high" slashType="close">
                            </Short_form_SchoolComparison>
                        </div>
                        <div class="ClassificationChart">
                            <BarChart :InjectData="Classification_GraphicalData" Id="Classification" Title=""
                                XAxis="examName" SeriesDataName="NumberOfPeople" ChartType="数字" Rotate='0'>
                            </BarChart>
                        </div>
                    </div>
                </div>
                <div class="BasicTemplate" v-if="Filtervalue.length > 0">
                    <div :id="`Compare_s${item.term_id}`" v-for="(item, index) in gradeList_Traverse" :key="index"
                        class="Compare_s">
                        <GradeAnalysisSch_Compare :ParentId="item.term_id" :ParentData="item"
                            :ref="`gradeAnalysis_${item.term_id}`" :Filterdata="Filterdata" :Filtervalue="Filtervalue"
                            :ParticipateInStatistics="ParticipateInStatistics && ParticipateInStatistics[item.grade] ? ParticipateInStatistics[item.grade] : null"
                            :GrippingPostureStatistics="GrippingPostureStatistics && GrippingPostureStatistics[item.grade] ? GrippingPostureStatistics[item.grade] : null"
                            :SittingPostureStatistics="SittingPostureStatistics && SittingPostureStatistics[item.grade] ? SittingPostureStatistics[item.grade] : null"
                            @EmptyData="handleEmptyData"
                            v-if="ParticipateInStatistics && ParticipateInStatistics[item.grade]">
                        </GradeAnalysisSch_Compare>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import Short_form_SchoolComparison from './appraisalCharts/Short_form_SchoolComparison.vue'
import BarChart from './appraisalCharts/HistoricalComparisonBarChart.vue'
import ComparativeColumnChart from './appraisalCharts/ComparativeColumnChart.vue'
import GradeAnalysisSch_Compare from './appraisalCharts/GradeAnalysisSch_Compare.vue'
import axios from 'axios';
import { Message } from 'element-ui';

/**
 * 学校「历次测评对比」总览页：顶部筛选学期与试卷，上方展示全校汇总表与图，
 * 下方按年级挂载 GradeAnalysisSch_Compare 子报告（参与/分布等走子组件）。
 */
export default {
    components: {
        Short_form_SchoolComparison,
        BarChart,
        ComparativeColumnChart,
        GradeAnalysisSch_Compare
    },
    props: {},
    data() {
        return {
            gradeList: [],
            gradeList_Traverse: [],
            Termid: null,
            Filtervalue: [],
            previousFilterValue: [],
            Filterdata: [],
            isEmpty: true,
            //参与情况表结构
            Participation_TableStructure: [
                {
                    fieldName: 'examName',
                    title: '测评'
                },
                {
                    fieldName: 'totalSign',
                    title: '注册人数（人）'
                },
                {
                    fieldName: 'totalSignIn',
                    title: '参与总人数（人）'
                },
                {
                    fieldName: 'totalSignInPercent',
                    title: '参与率（%）'
                },
            ],
            Participation_Data: null,
            Participation_GraphicalData: null,
            Participation_high: '21',
            //书写习惯表结构（握姿）
            GrippingPosture_TableStructure: [
                {
                    fieldName: 'examName',
                    title: '测评'
                },
                {
                    fieldName: 'errHold',
                    title: '握笔姿势错误人数（人）'
                    // title: '坐姿错误人数（人）'
                },
                {
                    fieldName: 'errHoldPercent',
                    title: '错误比例（%）'
                },
            ],
            GrippingPosture_Data: null,
            GrippingPosture_GraphicalData: null,
            GrippingPosture_high: '21',
            //书写习惯表结构（坐姿）
            SittingPosture_TableStructure: [
                {
                    fieldName: 'examName',
                    title: '测评'
                },
                {
                    fieldName: 'errSit',
                    title: '坐姿错误人数（人）'
                    // title: '握笔姿势错误人数（人）'
                },
                {
                    fieldName: 'errSitPercent',
                    title: '错误比例（%）'
                },
            ],
            SittingPosture_Data: null,
            SittingPosture_GraphicalData: null,
            SittingPosture_high: '21',
            //等级分布表结构
            Distribution_TableStructure: [
                {
                    fieldName: 'name',
                    title: '测评'
                },
                {
                    fieldName: 'good_count',
                    title: '优秀'
                },
                {
                    fieldName: 'qualified_count',
                    title: '良好'
                },
                {
                    fieldName: 'couhe',
                    title: '合格'
                },
                {
                    fieldName: 'need_improvement_count',
                    title: '待提升'
                },
                {
                    fieldName: 'count',
                    title: '总计'
                },
                {
                    fieldName: 'good_ratio',
                    title: '优良率（%）'
                },
                {
                    fieldName: 'qualified_ratio',
                    title: '合格率（%）'
                },
                {
                    fieldName: 'need_improvement_ratio',
                    title: '待提升率（%）'
                },
            ],
            Distribution_Data: null,
            Distribution_GraphicalData: null,
            Distribution_high: '21',
            //学生分级人数统计表结构
            Classification_TableStructure: [
                {
                    fieldName: 'examName',
                    title: '分类'
                },
                {
                    fieldName: 'NumberOfPeople',
                    title: '人数（人）'
                },
            ],
            Classification_Data: null,
            Classification_GraphicalData: null,
            Classification_high: '21',
            /** 原始参与情况（按试卷），用于筛选与统计 */
            ParticipationStatusStorage: null,
            originalDistributionData: null,
            /** 子组件 EmptyData 回调收集（学期无数据） */
            EmptyDataList: [],
            ParticipateInStatistics: null,
            GrippingPostureStatistics: null,
            SittingPostureStatistics: null,

        };
    },
    methods: {
        /** 拉取学校学期列表，首项为「全部年级」term_id=0 */
        async getGradeId() {
            const url = `https://spark-test.deploy.lezhireading.com/statistics/static/results/schoolterm/${this.$route.query.schoolId}`;

            try {
                const response = await axios.get(url, {
                    params: { noCache: Date.now() },
                    timeout: 50000,
                    headers: { 'Accept': 'application/json' }
                });
                const processedData = response.data.data.map(item => {
                    return {
                        ...item,
                        grade: Math.ceil(item.term_id / 2),
                        gradeText: `${Math.ceil(item.term_id / 2)}年级`
                    };
                });
                processedData.sort((a, b) => a.term_id - b.term_id);
                const allGradesItem = {
                    term_id: 0,
                    grade: 0,
                    gradeText: '全部年级',
                };
                processedData.unshift(allGradesItem);
                this.gradeList = processedData;
                this.gradeList_Traverse = processedData;
                // console.log(' this.gradeList_Traverse', this.gradeList_Traverse);

                this.Termid = 0;

            } catch (error) {
                return null;
            }
        },
        /** 学期选择：全部年级滚顶；否则滚到对应年级对比区块 */
        gradeChange(val) {
            // const isEmptyGrade = this.EmptyDataList.some(item => item.termId === val);
            let that = this;
            // this.$nextTick(() => {
            //     if (val === 0) {
            //         // 回到顶部
            //         window.scrollTo({
            //             top: 0,
            //             behavior: 'smooth'
            //         });
            //     } else {
            //         if (isEmptyGrade) {
            //             Message({
            //                 message: "此班级暂无数据",
            //                 center: true,
            //                 customClass: 'high-z-index-message'
            //             });
            //         } else {
            //             const element = document.getElementById(`Compare_s${val}`);
            //             if (element) {
            //                 const topPos = element.offsetTop - 150; // 下移300px
            //                 // 滚动到指定位置
            //                 window.scrollTo({
            //                     top: topPos,
            //                     behavior: 'smooth'
            //                 });
            //             }
            //         }
            //     }
            // });
            this.$nextTick(() => {
                if (val === 0) {
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                    return;
                }
                const gradeItem = this.gradeList.find(item => item.term_id === val);
                if (!gradeItem || !this.ParticipateInStatistics) return;
                if (this.ParticipateInStatistics[gradeItem.grade]) {
                    const element = document.getElementById(`Compare_s${val}`);
                    if (element) {
                        const topPos = element.offsetTop - 150;
                        window.scrollTo({
                            top: topPos,
                            behavior: 'smooth'
                        });
                    }
                } else {
                    Message({
                        message: '此年级暂无数据',
                        center: true,
                        customClass: 'high-z-index-message'
                    });
                }
            });
        },
        /** 单次测评参与率明细；examType 3/4/5 走汇总接口并带 defType */
        async joinInfo(termValue, examType, examName, defType) {
            let data = {
                schoolId: this.$route.query.schoolId,
                termKey: termValue,
                examType: examType,
            };
            let res;
            if ([3, 4, 5].includes(examType)) {
                data.defType = defType
            }
            try {
                if ([3, 4, 5].includes(examType)) {
                    res = await this.$Api.Report.joinInfoOverall(data);
                } else {
                    res = await this.$Api.Report.joinInfo(data);
                }

                res.data.dataList.forEach(item => {
                    item.examName = examName;
                    item.examType = examType;
                    item.totalSign = item.register;
                    item.totalSignIn = item.totalNum;
                    item.totalSignInPercent = item.participationRate;
                })
                return res;
            } catch (err) {
                console.error(err);
                return null;
            }
        },
        /** 握笔错误统计；周/月等类型显示为「/」 */
        async sitPosition(termValue, examType, examName, defType) {
            let data = {
                schoolId: this.$route.query.schoolId,
                termKey: termValue,
                examType: examType,
            };
            if ([3, 4, 5].includes(examType)) {
                data.defType = defType
            }
            try {
                let res = await this.$Api.Report.sitPosition(data);
                res.data.dataList.forEach(item => {
                    item.examName = examName;
                    item.examType = examType;
                    item.errHold = [3, 4, 5].includes(examType) ? '/' : item.wrongNum;
                    item.errHoldPercent = [3, 4, 5].includes(examType) ? '/' : item.ratio;
                })
                return res;
            } catch (err) {
                console.error(err);
                return null;
            }
        },
        /** 坐姿错误统计 */
        async holdAPenPosture(termValue, examType, examName, defType) {
            let data = {
                schoolId: this.$route.query.schoolId,
                termKey: termValue,
                examType: examType,
            };
            if ([3, 4, 5].includes(examType)) {
                data.defType = defType
            }
            try {
                let res = await this.$Api.Report.holdAPenPosture(data);
                res.data.dataList.forEach(item => {
                    item.examName = examName;
                    item.examType = examType;
                    item.errSit = [3, 4, 5].includes(examType) ? '/' : item.wrongNum;
                    item.errSitPercent = [3, 4, 5].includes(examType) ? '/' : item.ratio;
                })
                return res;
            } catch (err) {
                console.log(err);
                return null; // 发生错误时返回null
            }
        },
        // 获取测评试卷类型
        async getFilterexamination() {
            let that = this;
            // const classid = this.gradeId;
            // const url = `https://spark-test.deploy.lezhireading.com/statistics/static/results/examschool/${1018}`;
            const url = `https://spark-test.deploy.lezhireading.com/statistics/static/results/examschool/${this.$route.query.schoolId}`;

            try {
                const response = await axios.get(url, {
                    params: { noCache: Date.now() },
                    timeout: 50000,
                })
                const processedData = response.data.data.map(item => {
                    return {
                        ...item,
                        UniqueId: item.id + '_' + item.term_id,
                    };
                });
                // let GroupingData = [];
                // 初始化数据
                // this.ownexam = [];      // 清空旧数据
                this.originalFilterData = processedData; // 保存原始数据
                this.Filterdata = processedData; // 显示全部数据
                // console.log('this.Filterdata+++++++', this.Filterdata);

                this.Filtervalue = this.Filterdata.slice(0, 4).map(item => item.UniqueId);
                // GroupingData = this.Filterdata.map(item => item.id);
                // for (const [index, testId] of GroupingData.entries()) {
                //     try {
                //         // 等待当前请求完成后再进行下一个
                //         await this.getMatrixDiagram(testId, index, 'Initial');
                //     } catch (error) {
                //         console.error(`[顺序请求] 第 ${index + 1} 个请求失败，testId: ${testId}`, error);
                //         // 可选：如果某个请求失败你想中断后续请求，可以取消下面这行的注释
                //         // throw error; 
                //         // 如果想继续执行后续请求，可以忽略错误或记录
                //     }
                // }



            } catch (error) {
                return null;
            }
        },
        /** 试卷多选变更：同步子组件筛选项 */
        changeFiltervalue(val) {
            if (val.length < 1) {
                if (this.previousFilterValue && this.previousFilterValue.length > 0) {
                    this.Filtervalue = [...this.previousFilterValue];
                    return;
                }
            } else {
                this.previousFilterValue = [...val];
            }
            // 如果没有选中任何试卷，则显示全部数据
            this.LevelDistributionScreening();
            this.$nextTick(() => {
                this.gradeList_Traverse.forEach(item => {
                    const refName = `gradeAnalysis_${item.term_id}`;
                    const instance = this.$refs[refName];
                    if (instance && instance.length > 0 && typeof instance[0].LevelDistributionScreening === 'function') {
                        instance[0].LevelDistributionScreening();
                    }
                });
            });



        },

        /** 试卷列表 + 默认选中前 4 场，作为筛选数据源 */
        async getSchoolParticipation() {
            const data = {
                schoolId: this.$route.query.schoolId,
            };
            try {
                const resData = await this.$Api.Report.getSchoolParticipation(data);
                if (Array.isArray(resData) && resData.length > 0) {
                    this.ParticipationStatusStorage = resData;
                    this.Filtervalue = this.ParticipationStatusStorage.slice(0, 4).map(item => item.keyvalue);
                    this.Filterdata = this.ParticipationStatusStorage;
                }
            } catch (error) {

            }
        },
        /** 按试卷列表拉取参与、握笔、坐姿并汇总为年级维度 */
        async ParticipationDataStatistics(data) {
            if (!Array.isArray(data) || data.length === 0) {
                return;
            }
            let gradeDetails = [];
            let GrippingPosture = [];
            let SittingPosture = [];
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                // 获取参与情况
                let result = await this.joinInfo(element.termKey, element.type, element.examName, element.defType);
                // console.log('result', result);

                let totalRegister = 0;
                let totalNum = 0;
                if (result && result.data && result.data.dataList) {
                    result.data.dataList.forEach(item => {
                        totalRegister += Number(item.totalSign) || 0;
                        totalNum += Number(item.totalSignIn) || 0;
                    });
                }
                let participationRate = 0;
                if (totalRegister > 0) {
                    participationRate = ((totalNum / totalRegister) * 100);
                }
                gradeDetails.push({
                    type: element.type,
                    examName: element.examName,
                    // totalSign: totalRegister,
                    // totalSignIn: totalNum,
                    // totalSignInPercent: participationRate.toFixed(2),
                    // dataList: result && result.data && result.data.dataList ? result.data.dataList : []
                    totalSign: element.totalSign ? (element.totalSign) : '/',
                    totalSignIn: element.totalSignIn ? (element.totalSignIn) : '/',
                    totalSignInPercent: element.totalSignInPercent ? (element.totalSignInPercent).toFixed(2) : '/',
                    dataList: result && result.data && result.data.dataList ? result.data.dataList : []
                });
                let result_sitPosition = await this.sitPosition(element.termKey, element.type, element.examName, element.defType);
                let errtotalNumberOfPeople = 0;
                let errtotalRatio = 0;
                if (result_sitPosition && result_sitPosition.data && result_sitPosition.data.dataList) {
                    result_sitPosition.data.dataList.forEach(item => {
                        errtotalNumberOfPeople += Number(item.errHold) || 0;
                        errtotalRatio += Number(item.errHoldPercent) || 0;
                    });
                }
                let GrippingPostureRate = 0;
                if (errtotalNumberOfPeople > 0) {
                    GrippingPostureRate = (errtotalRatio / result_sitPosition.data.dataList.length).toFixed(2);
                }
                GrippingPosture.push({
                    type: element.type,
                    examName: element.examName,
                    // errHold: errtotalNumberOfPeople,
                    // errHoldPercent: GrippingPostureRate,
                    // errHold: [3, 4, 5].includes(element.type) ? '/' : errtotalNumberOfPeople,
                    // errHoldPercent: [3, 4, 5].includes(element.type) ? '/' : GrippingPostureRate,
                    errHold: element.errHold ? (element.errHold) : '/',
                    errHoldPercent: element.errHoldPercent ? (element.errHoldPercent).toFixed(2) : '/',
                    dataList: result_sitPosition && result_sitPosition.data && result_sitPosition.data.dataList ? result_sitPosition.data.dataList : []
                });
                let result_holdAPenPosture = await this.holdAPenPosture(element.termKey, element.type, element.examName, element.defType);
                let HandtotalNumberOfPeople = 0;
                let HandtotalRatio = 0;
                if (result_holdAPenPosture && result_holdAPenPosture.data && result_holdAPenPosture.data.dataList) {
                    result_holdAPenPosture.data.dataList.forEach(item => {
                        HandtotalNumberOfPeople += Number(item.errSit) || 0;
                        HandtotalRatio += Number(item.errSitPercent) || 0;
                    });
                }
                let SittingPostureRate = 0;
                if (HandtotalNumberOfPeople > 0) {
                    SittingPostureRate = (HandtotalRatio / result_holdAPenPosture.data.dataList.length).toFixed(2);
                }
                SittingPosture.push({
                    type: element.type,
                    examName: element.examName,
                    // errSit: HandtotalNumberOfPeople,
                    // errSitPercent: SittingPostureRate,
                    // errSit: [3, 4, 5].includes(element.type) ? '/' : HandtotalNumberOfPeople,
                    // errSitPercent: [3, 4, 5].includes(element.type) ? '/' : SittingPostureRate,
                    errSit: element.errSit ? (element.errSit) : '/',
                    errSitPercent: element.errSitPercent ? (element.errSitPercent).toFixed(2) : '/',
                    dataList: result_holdAPenPosture && result_holdAPenPosture.data && result_holdAPenPosture.data.dataList ? result_holdAPenPosture.data.dataList : []
                });
            }
            this.Participation_Data = gradeDetails;
            // console.log('this.Participation_Data',this.Participation_Data);
            
            this.Participation_GraphicalData = gradeDetails;
            this.GrippingPosture_Data = GrippingPosture;
            this.GrippingPosture_GraphicalData = GrippingPosture.filter(item => ![3, 4, 5].includes(item.type));
            // 获取书写习惯 坐姿
            this.SittingPosture_Data = SittingPosture;
            this.SittingPosture_GraphicalData = SittingPosture.filter(item => ![3, 4, 5].includes(item.type));
            // 参与情况数据按年级分类
            this.ParticipateInStatistics = this.groupDataByGrade(this.Participation_Data);
            // console.log(' this.ParticipateInStatistics+++++', this.ParticipateInStatistics);
            

            // 握笔姿势数据按年级分类
            this.GrippingPostureStatistics = this.groupDataByGrade(this.GrippingPosture_Data);
            this.SittingPostureStatistics = this.groupDataByGrade(this.SittingPosture_Data);

        },
        /** 将含 dataList 的汇总行按 gradeNum 拆成「年级 → 行数组」供子组件取用 */
        groupDataByGrade(sourceData) {
            let newData = sourceData.flatMap(item => item.dataList || []);
            const result = {};
            newData.forEach(item => {
                const gradeNum = item.gradeNum || '未知年级';
                if (!result[gradeNum]) {
                    result[gradeNum] = [];
                }
                result[gradeNum].push(item);
            });
            return result;
        },
        /** 学校等级分布（比例转百分比） */
        async getDistribution() {
            const url = `https://spark-test.deploy.lezhireading.com/statistics/static/results/valuebyschoolnew/${this.$route.query.schoolId}`;
            try {
                const response = await axios.get(url, {
                    params: { noCache: Date.now() },
                    timeout: 50000,
                    headers: { 'Accept': 'application/json' }
                });
                const raw = response.data && response.data.data;
                if (!Array.isArray(raw)) {
                    this.originalDistributionData = [];
                    return;
                }
                this.originalDistributionData = raw.map(item => {
                    const filterItem = this.Filterdata.find(filter => filter.keyvalue === item.keyvalue);
                    return {
                        ...item,
                        name: filterItem ? filterItem.examName : item.name,
                        good_ratio: parseFloat((item.good_ratio * 100).toFixed(2)),
                        qualified_ratio: parseFloat((item.qualified_ratio * 100).toFixed(2)),
                        need_improvement_ratio: parseFloat((item.need_improvement_ratio * 100).toFixed(2))
                    };
                });
            } catch (error) {
                return null;
            }
        },
        /** 全校学生分级人数（用于顶部「学生分级人数统计」表） */
        async getClassification() {
            const url = `https://spark-test.deploy.lezhireading.com/statistics/static/results/owntypebyschool/${this.$route.query.schoolId}`;
            try {
                const response = await axios.get(url, {
                    params: { noCache: Date.now() },
                    timeout: 50000,
                    headers: { 'Accept': 'application/json' }
                });
                const raw = response.data && response.data.data;
                if (!Array.isArray(raw) || raw.length === 0) {
                    return;
                }
                this.TypeGrouping(raw);
            } catch (error) {
                return null;
            }

        },
        /**
         * 与年级对比页一致：testdata 四象限统计 → 优先级打标签 → 汇总 Classification 表。
         * 接口字段：range_x/y、std_deviation_x/y、testdata 等。
         */
        TypeGrouping(data) {
            const list = Array.isArray(data) ? data : [];
            const THRESHOLD_X = 69.3;
            const THRESHOLD_Y = 64.8;
            this._schCountQuadrants(list, THRESHOLD_X, THRESHOLD_Y);
            this._schAssignReportLabels(list);
            this._schBuildClassificationTable(list);
        },

        _schCountQuadrants(students, thresholdX, thresholdY) {
            students.forEach((student) => {
                let xiangxian1 = 0;
                let xiangxian2 = 0;
                let xiangxian3 = 0;
                let xiangxian4 = 0;
                let countall = 0;
                if (Array.isArray(student.testdata)) {
                    countall = student.testdata.length;
                    student.testdata.forEach((test) => {
                        const x = test.x;
                        const y = test.y;
                        if (typeof x !== 'number' || typeof y !== 'number') return;
                        if (x >= thresholdX && y >= thresholdY) xiangxian1++;
                        else if (x < thresholdX && y < thresholdY) xiangxian3++;
                        else if (x < thresholdX && y >= thresholdY) xiangxian2++;
                        else if (x >= thresholdX && y < thresholdY) xiangxian4++;
                    });
                }
                student.xiangxian1 = xiangxian1;
                student.xiangxian2 = xiangxian2;
                student.xiangxian3 = xiangxian3;
                student.xiangxian4 = xiangxian4;
                student.countall = countall;
                student.reportType = [];
            });
        },

        _schAssignReportLabels(students) {
            students.forEach((student) => {
                if (
                    (student.xiangxian3 / student.countall >= 0.5) ||
                    (student.range_x < -5 && student.range_y < -5) ||
                    (student.range_y < -10 && student.xiangxian1 / student.countall < 0.6)
                ) {
                    student.reportType.push('重点型');
                    return;
                }
                if (student.std_deviation_x >= 8 || student.std_deviation_y >= 8) {
                    student.reportType.push('波动型');
                    return;
                }
                if ((student.xiangxian2 / student.countall >= 0.4) ||
                    (student.range_y > 5 && student.range_x <= 0)) {
                    student.reportType.push('天赋型');
                    return;
                }
                if (student.xiangxian1 / student.countall >= 0.6 && student.range_x >= 2 && student.range_y >= 2) {
                    student.reportType.push('双优型');
                    return;
                }
                if ((student.range_x >= 6 && student.range_y <= 3) ||
                    (student.xiangxian4 / student.countall >= 0.4 && student.range_x > 0)) {
                    student.reportType.push('进取型');
                    return;
                }
                if (student.range_x > 0 && student.range_y > 0 && student.std_deviation_x < 8 && student.std_deviation_y < 8) {
                    student.reportType.push('稳健型');
                    return;
                }
                if (
                    (student.xiangxian1 / student.countall > 0.2 && student.xiangxian3 / student.countall > 0.1) ||
                    (student.range_y < 0 && student.range_x >= 0) ||
                    (student.range_x < 0 && student.range_y >= 0) ||
                    (student.range_x < 0 && student.range_y < 0 && student.xiangxian1 / student.countall > 0.3)
                ) {
                    student.reportType.push('潜能型');
                    return;
                }
                student.reportType.push('重点型');
            });
        },

        _schBuildClassificationTable(data) {
            const allTypes = ['双优型', '稳健型', '重点型', '进取型', '潜能型', '波动型', '天赋型'];
            const groupedByType = {};
            allTypes.forEach((type) => { groupedByType[type] = []; });

            data.forEach((student) => {
                if (!Array.isArray(student.reportType)) return;
                student.reportType.forEach((type) => {
                    if (allTypes.includes(type)) groupedByType[type].push(student);
                });
            });

            this.Classification_Data = [
                { examName: '双优型', NumberOfPeople: groupedByType['双优型'].length },
                { examName: '稳健型', NumberOfPeople: groupedByType['稳健型'].length },
                { examName: '天赋型', NumberOfPeople: groupedByType['天赋型'].length },
                { examName: '进取型', NumberOfPeople: groupedByType['进取型'].length },
                { examName: '潜能型', NumberOfPeople: groupedByType['潜能型'].length },
                { examName: '波动型', NumberOfPeople: groupedByType['波动型'].length },
                { examName: '重点型', NumberOfPeople: groupedByType['重点型'].length },
               
            ];
            this.Classification_GraphicalData = this.Classification_Data;
        },
        /**
         * 无筛选：全量参与统计 + 全量等级分布；有筛选：仅统计选中试卷。
         */
        LevelDistributionScreening() {
            if (!this.Filtervalue || this.Filtervalue.length === 0) {
                this.ParticipationDataStatistics(this.ParticipationStatusStorage);
                this.Distribution_Data = this.originalDistributionData;
                this.Distribution_GraphicalData = this.originalDistributionData;
                return;
            }

            if (this.ParticipationStatusStorage && Array.isArray(this.ParticipationStatusStorage)) {
                const Participate = this.ParticipationStatusStorage.filter(item =>
                    this.Filtervalue.includes(item.keyvalue));
                this.ParticipationDataStatistics(Participate);
            }
            if (this.originalDistributionData && Array.isArray(this.originalDistributionData)) {
                const filteredData = this.originalDistributionData.filter(item =>
                    this.Filtervalue.includes(item.keyvalue));
                this.Distribution_Data = filteredData;
                this.Distribution_GraphicalData = filteredData;
            }
        },
        /** 进入页面：学期列表 → 试卷 → 分布 → 分级统计 → 按筛选刷新表图 */
        async fetchDataInOrder() {
            try {
                await this.getGradeId();
                await this.getSchoolParticipation();
                await this.getDistribution();
                await this.getClassification();
                this.LevelDistributionScreening();
            } catch (error) {
                console.error("Error fetching data in order:", error);
            }
        },
        handleEmptyData(data) {
            this.EmptyDataList.push(data);
        }

    },
    mounted() {

        // this.$message('这是一条消息提示');
        // Message.success('111111111111')
        this.fetchDataInOrder();
    },
}
</script>
<style>
.el-message {
    z-index: 9999999 !important;
}

.high-z-index-message {
    z-index: 9999999 !important;
}

.el-message--success {
    z-index: 9999999 !important;
}
</style>
<style scoped lang="less">
.ComparisonOfschHistory {
    padding-top: 120px;
    width: 100%;
    background-color: #f4f7f9;



    //公共类

    .Secondary_heading {
        display: flex;
        align-items: center;
        margin-top: 36px;
        // margin-right: 54px;
        // margin-left: 54px;

        .vertical_grain_icon {
            width: 4px;
            height: 18px;
            background: #01B68D;
            border-radius: 2px;
        }

        .title {
            font-size: 18px;
            color: #01B68D;
            margin-left: 10px;
            // font-weight: bold;
        }
    }

    // 顶部筛选
    .filtrate {
        background: #FFFFFF;
        height: 50px;
        // padding-right: 101.5px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        // border: 1px solid #000;
        position: fixed;
        width: 100%;
        top: 60px;
        z-index: 999999;

        .el-select {
            margin-left: 21px;
        }

        /deep/ .el-select .el-input.is-focus .el-input__inner {
            border-color: #00B384;
        }

        /deep/ .el-select .el-input__inner:focus {
            border-color: #00B384;
        }

        /deep/ .el-select-dropdown__item.selected {
            color: #00B384 !important;
        }

        .export {
            background-color: #fff;
            box-sizing: border-box;
            padding-right: 202px;
            justify-content: flex-end;

            .wrap {
                cursor: pointer;
                margin-left: 21px;

                img {
                    width: 22px;
                    margin-right: 10px;
                }

                color: #999999;
                font-size: 15px;
            }
        }
    }

    .Compare {
        /deep/ .el-select-dropdown__item {
            // padding:  20px !important;
            // color: #00B384 !important;
            padding-left: 20px !important;
            padding-right: 20px !important;
        }

        /deep/ .el-select__tags {
            // background-color: #f2fbf9 !important;
            max-width: none !important;
            // border: 1px solid #000;
        }
    }

    .type_title {
        width: 1514px;
        margin: auto;
        margin-bottom: 20px;
        margin-top: 20px;

        h1 {
            color: #01B58C;
            font-size: 26px;
            font-weight: bold;
            margin-bottom: 15px;
        }

        h2 {
            color: #01B58C;
            font-size: 18px;
            font-weight: bold;
        }
    }

    .overall_situation {
        margin: auto;
        width: 1514px;
        margin-bottom: 20px;

        .BasicTemplate {
            background-color: #fff;
            border-radius: 15px;
            border: 1px solid transparent;
            margin-bottom: 17px;
            box-sizing: border-box;
            padding-bottom: 57px;
            // min-height: 500px;
            flex-wrap: wrap;
            padding: 0 54px;
            padding-bottom: 100px;
            // border: 1px solid #000;


            .content {
                margin-top: 36px;

                // border: 1px solid #000;
                .Participation_Chart {
                    // height: 300px;
                    height: 400px;
                    // border: 1px solid #000;
                    margin-top: 30px;
                }

                .ClassifiedStatistics {
                    width: 28%;
                    // border: 1px solid #000;
                    margin-right: 2%;
                }

                .ClassificationChart {
                    width: 70%;
                    height: 350px;
                    // border: 1px solid #000;
                }
            }

            .Classification {
                display: flex;
                align-items: flex-start;
            }
        }


    }


    .Graphics_dialog {
        width: 100%;
        height: 700px;
        // border: 1px solid #000;
    }

    /deep/.filter_select {
        width: 320px !important;

        .el-select__tags>span {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .el-select__tags-text {
            max-width: 200px !important;
            width: auto !important;
        }
    }
}
</style>